// extracted by mini-css-extract-plugin
export default {"itemCheckbox":"ImagensProdutos_itemCheckbox__lfNoL"};